import { Grid, makeStyles } from '@material-ui/core';
import { redirectTo, RouteComponentProps } from '@reach/router';
import React, { useEffect } from 'react';
import Image from '../assets/login-background.png';
import { Layout, ResetPasswordComponent } from '../components';
import { getToken } from '../lib/storage-util';

const useStyles = makeStyles(() => ({
  resetContainer: {
    width: '100%',
    minHeight: '100%',
    backgroundImage: `url(${Image})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  },
}));

const ResetPassword: React.FC<RouteComponentProps> = () => {
  const classes = useStyles();
  useEffect(() => {
    document.title = 'Sales Mediamyynti - Reset password';
    const token = getToken();
    if (token) {
      redirectTo('/logout');
    }
  }, []);
  return (
    <Layout>
      <Grid wrap="nowrap" className={classes.resetContainer} container>
        <ResetPasswordComponent />
      </Grid>
    </Layout>
  );
};

export default ResetPassword;
